import { InfoPageOrderedList } from './InfoPageOrderedList.style';

export default InfoPageOrderedList;
